module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "tab-bar"
  }, [_c('h6', [_c('ul', {
    staticClass: "fx"
  }, _vm._l((_vm.listBar), function(item) {
    return _c('li', {
      class: {
        'active': _vm.activeBar == item.type
      },
      on: {
        "click": function($event) {
          return _vm.handleClickTabBar(item.type)
        }
      }
    }, [_vm._v(_vm._s(item.title)), _c('i')])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-500d7b54","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/zui/TabBar.vue
// module id = 844
// module chunks = 0